import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '../../../core/pipes/capitalize.pipe';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HelpService } from '../../../core/services/help/help.service';
import { SanitizeHtmlPipe } from '../../pipes/sanitizant-pipe';
import { Router, RouterModule } from '@angular/router';
import { PlatformServices } from '../../../core/services/platform/platform.service';
import { MaterialModule } from '../../modules/material/material.module';

@Component({
  selector: 'app-cookies-dialog',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule,ReactiveFormsModule, TranslateModule, MaterialModule,
    CapitalizePipe, SanitizeHtmlPipe, RouterModule],
  templateUrl: './cookies-dialog.component.html',
  styleUrl: './cookies-dialog.component.scss'
})
export class CookiesDialogComponent {

  step = 0;

  success = false;

  files: any[] = [];
  filesService: any[] = [];

  loadingFile: boolean = false;

  loadingService: boolean = false;

  isPublicRoute = false;

  showClose = false;

  private routesPublic = ['login', 'changepassword', 'forgot-password']; // List of routes that do not have a sidebar & navbar

  formControl = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required])
  });

  dialogRef!: MatDialogRef<CookiesDialogComponent>;

  isPublicRoutes: boolean = false;

  isMobile = false;

  constructor(
    private helpService: HelpService,
    private router: Router,
    private dialog: MatDialog,
    private platformServices: PlatformServices) {
    this.isMobile = this.platformServices.currentScreenSize === 'Tablet' || this.platformServices.currentScreenSize === 'Handset';

    if (!this.isMobile) {
      this.dialogRef = inject(MatDialogRef);
    }
    
    this.isPublicRoute = this.router.url === '/' || this.routesPublic.some(r => this.router.url.includes(r));

    if (this.isMobile && this.isPublicRoute) {
      this.showClose = true;
    } else if (!this.isMobile) {
      this.showClose = true;
    } else if (this.isMobile && !this.isPublicRoute) {
      this.showClose = false
    }

  }

  closeDialog() {
    this.helpService.hideCookies();
  }

}
